<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Banner">Add Banners</v-flex> 
                    <v-flex v-else>Update Banners</v-flex>   
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;" v-if="!Update_Banner">
                        <v-flex>
                            <v-text-field v-model="Banner_Text" label='Banner Text'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field v-model="Banner_URL" label='Banner URL'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field v-model="Banner_Position" label='Banner Position'></v-text-field>
                        </v-flex>
                        <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                            <v-flex >
                                <img id="img_banner" :src="url" width="100%" style="min-height: 230px;max-height: 230px;"/>
                            </v-flex>
                            <v-flex style="text-align: center;">
                                <v-btn color="success" @click="$refs.inputUpload.click()">Upload Course Banner</v-btn>
                                <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" >
                            </v-flex>
                        </div>
                    </v-flex>
                    <v-flex wrap style="padding: 10px;" v-else>
                        <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                        <v-flex >
                            <img :src="Banner_Image" width="100%" style="min-height: 230px;max-height: 230px;"/>
                        </v-flex>
                        </div>
                        <v-flex>
                            <v-text-field v-model="Banner_Text" label='Banner Text'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field v-model="Banner_URL" label='Banner URL'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field v-model="Banner_Position" label='Banner Position'></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-switch v-model="Enable" :label="`Enable : ${Enable.toString()}`" ></v-switch>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn v-if="!Update_Banner" color="success" @click="SubmitBannerImage">Add Banner</v-btn>
                        <v-btn v-else color="success" @click="UpdateBannerDetails">Update Banner</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>

export default {
    props: ['dialog'],
    data(){
        return {

            url                     : null,
            Banner                  : null,
            Banner_Text             : '',
            Banner_Position         : 0,
            Banner_URL              : '',
            Banner_Id               : '',
            Banner_Image            : '',
            Enable                  : false,
            Update_Banner           : false

        }
    },
    methods:{
        CloseDialog(){
            
            this.ClearBanner()
            this.$emit('close')
        },
        SelectedFile(e){

            this.Banner      = e.target.files[0]
            this.url         = URL.createObjectURL(this.Banner);
            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Banner Image Selected","Color":"green","Close": false });

        },
        SubmitBannerImage(){

            if(this.Banner){

                const fd = new FormData()
                fd.append('Banner_Image',this.Banner,this.Banner.name)
                fd.append('Banner_Text',this.Banner_Text)
                fd.append('Banner_Position',parseInt(this.Banner_Position))
                fd.append('Banner_URL',this.Banner_URL)
                
                this.$http.post(`${this.$store.getters.GetProductionUrl}/banners/addbanners`,fd)
                            .then(response =>{
                                
                                this.$store.commit('SetIndividualBanner',response['data']['response'])
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded","Color":"green","Close": false });
                                this.CloseDialog()
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Uploading","Color":"red","Close": false });
                            })
            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Selected Banner Image","Color":"red","Close": false });
            }
        },
        ClearBanner(){

            this.url         = null
            this.Banner      = null
            this.Banner_Text = ''
            this.Banner_URL  = ''
            this.Banner_Position = 0
            this.Banner_Id   = ''
            this.Enable      = false
            this.Banner_Image = ''
            !this.Update_Banner ? this.$refs.inputUpload.value = "" : ""
            this.Update_Banner = false
        },
        UpdateBanner(Banner_Details){
            
            this.Banner_Image    = Banner_Details['Banner_Image']
            this.Banner_Text     = Banner_Details['Banner_Text']
            this.Banner_Position = Banner_Details['Banner_Position']
            this.Banner_URL      = Banner_Details['Banner_URL']
            this.Enable          = Banner_Details['Enable']
            this.Banner_Id       = Banner_Details['_id']
            this.Update_Banner = true
        },
        UpdateBannerDetails(){

            let Update_Details = {}
            Update_Details['_id'] = this.Banner_Id
            Update_Details['update'] = {}
            Update_Details['update']['Banner_Text'] = this.Banner_Text
            Update_Details['update']['Banner_Position'] = parseInt(this.Banner_Position)
            Update_Details['update']['Banner_URL'] = this.Banner_URL
            Update_Details['update']['Enable'] = this.Enable

            this.$http.post(`${this.$store.getters.GetProductionUrl}/banners/updatebanners`,Update_Details)
                        .then(response =>{
                            
                            this.$store.commit('UpdateIndividualBanner',response['data']['response'])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                           this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Uploading","Color":"red","Close": false });
                        })
        }
    }
}
</script>
<style scoped>

</style>